import React from "react";
import { Helmet } from "react-helmet";
import { makeStyles } from "@mui/styles";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import CurrentSchedule from "./CurrentSchedule.js";
import UpcomingSchedule from "./UpcomingSchedule.js";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={1}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
});

export default function Schedule() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <React.Fragment>
      <Helmet>
        <title>LabAsService</title>
      </Helmet>

      <div
        className={classes.root}
        style={{ paddingRight: "30px", paddingLeft: "30px" }}
      >
        <AppBar position="static" style={{ backgroundColor: "#ffff" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="simple tabs example"
          >
            <Tab label="Today Schedule" {...a11yProps(0)} />
            <Tab label="UpComing Schedule" {...a11yProps(1)} />
          </Tabs>
        </AppBar>
        <TabPanel value={value} index={0}>
          <Box
            sx={{
              backgroundColor: "background.default",
              minHeight: "100%",
              py: 2,
            }}
          >
            <CurrentSchedule />
          </Box>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Box
            sx={{
              backgroundColor: "background.default",
              minHeight: "100%",
              py: 2,
            }}
          >
            <UpcomingSchedule />
          </Box>
        </TabPanel>
      </div>
    </React.Fragment>
  );
}